<script>
import AWS from 'aws-sdk'
import { isoLangs } from '@utils/language-codes'

export default {
  data() {
    return {
      loaded: true,
      results: null,
      translate: null,
      isoLangs: isoLangs,
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'translate' })
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  methods: {
    getIsoLang(code) {
      const res = isoLangs.filter((i) => i.code === code)[0]
      if (res) {
        return res
      }
      return { nativeName: 'N/A', name: 'N/A' }
    },
    doCopy(text) {
      this.$copyText(text).then(
        () => {
          this.$notification.success({
            message: `Field Copied!`,
            duration: 2,
          })
        },
        () => {
          this.$notification.error({
            message: `Failed to Copy`,
            duration: 2,
          })
        }
      )
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            Text: values?.source_text || '',
            SourceLanguageCode: values?.source_lang || 'auto',
            TargetLanguageCode: 'en',
          }
          AWS.config.region = 'us-east-1' // Region
          AWS.config.credentials = new AWS.Credentials(
            process.env.VUE_APP_AWS_TRANSLATE_ACCESS,
            process.env.VUE_APP_AWS_TRANSLATE_SECRET
          )

          const translate = new AWS.Translate({ region: AWS.config.region })
          translate.translateText(params, (err, data) => {
            if (err) {
              this.$notification.error({
                message: 'error:' + err.message + err.stack,
                duration: 2,
              })
            }
            if (data) {
              this.results = data
            }
          })
        } else {
          this.$notification.error({
            message: 'error',
            duration: 2,
          })
        }
      })
    },
  },
}
</script>

<template>
  <div class="translate--container">
    <div v-if="!loaded" class="loader">
      <a-icon
        type="loading"
        style="padding-left: 8px; font-size: 24px; color: #1890ff"
        spin
      />
    </div>
    <div v-else>
      <a-card style="width: 100%">
        <a-row>
          <a-form :form="form" @submit="handleSubmit">
            <a-form-item label="Select a Source Language">
              <a-select
                v-decorator="[
                  'source_lang',
                  {
                    initialValue: 'Auto',
                    rules: [
                      {
                        required: true,
                      },
                    ],
                  },
                ]"
              >
                <a-select-option
                  v-for="(l, i) in isoLangs"
                  :key="l.name + i"
                  :value="l.code"
                >
                  {{ l.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item>
              <a-textarea
                v-decorator="[
                  'source_text',
                  {
                    initialValue: '你好',
                    rules: [
                      {
                        required: true,
                        message: 'Please input your source text!',
                      },
                    ],
                  },
                ]"
                placeholder="Source Text"
              >
                <a-icon
                  slot="prefix"
                  type="book"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-textarea>
            </a-form-item>

            <a-form-item>
              <a-button type="primary" html-type="submit"> Translate </a-button>
            </a-form-item>
          </a-form>

          <a-card v-if="results" style="width: 100%">
            <a-row>
              <a-descriptions
                v-if="results"
                title="Results"
                bordered
                :column="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }"
              >
                <a-descriptions-item label="Translated Text">
                  {{ results.TranslatedText }}
                  <a-button
                    size="small"
                    shape="circle"
                    @click="doCopy(results.TranslatedText)"
                  >
                    <a-icon type="copy" />
                  </a-button>
                </a-descriptions-item>

                <a-descriptions-item label="Source Language">
                  Code: {{ results.SourceLanguageCode }}<br />
                  Name: {{ getIsoLang(results.SourceLanguageCode).name }}<br />
                  Native Name:
                  {{ getIsoLang(results.SourceLanguageCode).nativeName }}
                </a-descriptions-item>
              </a-descriptions>
            </a-row>
          </a-card>
        </a-row>
      </a-card>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.loader {
  padding: 2rem;
  text-align: center;
}

.button--container {
  width: 100%;
  margin-top: 8px;

  button {
    width: 100%;
  }
}

.translate--container {
  height: 100%;
  overflow-y: scroll;
}
</style>
